import { checkout } from "./checkout.en";
import { cookies } from "./cookies.en";
import { footer } from "./footer";
import { notifications } from "./notifications.en";
import { register } from "./register.en";
import { login } from "./login.en";
import { orderDetails } from "./order-details.en";
import { actions } from "./actions.en";
import { repairAnalysisInfo } from "./repairAnalysisInfo.en";
import { welcomeJomatik } from "./welcome-jomatik.en";
import { printmode } from "./printmode.en";
import { discount } from "./discount.en";

export const en = {
  checkout,
  cookies,
  footer,
  notifications,
  register,
  login,
  orderDetails,
  actions,
  repairAnalysisInfo,
  welcomeJomatik,
  printmode,
  discount,
};
